import { Modal, Spin, Checkbox, List, message } from "antd";
import React from "react";
import api from "../../URL/axiosConfig";

const ModalDownlinkQueueNode = ({ open, setOpen, devEui }) => {
  const [loading, setLoading] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [selectedIds, setSelectedIds] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      if (open) {
        setLoading(true);
        setSelectedIds([]);
        try {
          if (devEui) {
            let response = await api({
              url: "/action/downlink/list/bulk",
              method: "GET",
              params: {
                devEui: devEui,
              },
            });

            if (Array.isArray(response.data.data)) {
              setData(response.data.data);
            } else {
              setData([]);
            }
          }
        } catch (error) {
          console.error("Error fetching node list:", error);
          message.error("Gagal mengambil data list");
          setData([]);
        } finally {
          setLoading(false);
        }
      } else {
        setData([]);
      }
    };

    fetchData();
  }, [open, devEui]);

  const onCheckboxChange = checkedValues => {
    setSelectedIds(checkedValues);
  };

  const handleSubmit = async () => {
    if (selectedIds.length === 0) {
      message.warning("Pilih setidaknya satu item!");
      return;
    }

    setSubmitting(true);
    try {
      const payload = {
        devEui: devEui,
        ids: selectedIds,
      };

      await api({
        url: "/action/downlink/custom/node/submit",
        method: "POST",
        data: payload,
      });

      message.success("Berhasil mengirim data!");
      setOpen(false);
    } catch (error) {
      console.error("Error submitting data:", error);
      message.error("Gagal mengirim data.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title="Select Downlink Options"
      visible={open}
      onCancel={() => setOpen(false)}
      onOk={handleSubmit}
      confirmLoading={submitting}
      width={900} // Lebar modal ditambah agar 3 kolom terlihat rapi
      okText="Submit"
      cancelText="Cancel"
    >
      <Spin spinning={loading}>
        <div
          style={{ maxHeight: "60vh", overflow: "auto", overflowX: "hidden" }}
        >
          <Checkbox.Group
            style={{ width: "100%" }}
            value={selectedIds}
            onChange={onCheckboxChange}
          >
            <List
              // PERUBAHAN DISINI: Membuat Grid 3 Kolom
              grid={{ gutter: 16, column: 3 }}
              dataSource={data}
              renderItem={item => (
                <List.Item key={item.id}>
                  <Checkbox value={item.id} style={{ width: "100%" }}>
                    {/* Text truncate biar rapi jika nama kepanjangan */}
                    <span
                      title={item.name}
                      style={{
                        display: "inline-block",
                        maxWidth: "250px",
                        verticalAlign: "middle",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {item.name}
                    </span>
                  </Checkbox>
                </List.Item>
              )}
            />
          </Checkbox.Group>

          {!loading && data.length === 0 && (
            <div
              style={{ textAlign: "center", padding: "20px", color: "#999" }}
            >
              No data available
            </div>
          )}
        </div>
      </Spin>
    </Modal>
  );
};

export default ModalDownlinkQueueNode;
